import { Box, Typography } from '@mui/material';
import CustomModal from '@/components/CustomModal/CustomModal';

interface VideoPreviewModalProps {
  open: boolean;
  onClose: () => void;
  videoUrl: string | null;
  title: string;
  summary?: string | null;
}

const VideoPreviewModal = ({ open, onClose, videoUrl, title, summary }: VideoPreviewModalProps) => {
  if (!videoUrl) return null;

  return (
    <CustomModal
      open={open}
      handleClose={onClose}
      boxSx={{
        maxWidth: 720,
        width: '90vw',
      }}
    >
      <Typography variant="h6" fontWeight={600} sx={{ mb: 2 }}>
        {title}
      </Typography>

      <Box
        sx={{
          borderRadius: 2,
          overflow: 'hidden',
          bgcolor: 'black',
          mb: summary ? 2 : 0,
        }}
      >
        <Box
          component="video"
          controls
          autoPlay
          playsInline
          src={videoUrl}
          sx={{
            width: '100%',
            maxHeight: '60vh',
            display: 'block',
          }}
        />
      </Box>

      {summary && (
        <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.6 }}>
          {summary}
        </Typography>
      )}
    </CustomModal>
  );
};

export default VideoPreviewModal;
